import { PostData } from "./FetchData";
import { parseLiveChatResponse } from "./liveChatUtils";

const MS5 = "ms5";
const BASE = "api/v1/live-chat";

function requireWebsiteId(websiteId) {
	if (websiteId == null || websiteId === "") {
		return { ok: false, message: "websiteId is required", data: null };
	}
	return null;
}

export async function getAgentToken(websiteId) {
	const missing = requireWebsiteId(websiteId);
	if (missing) return missing;
	const res = await PostData(MS5, `${BASE}/agent/token`, { websiteId: Number(websiteId) });
	return parseLiveChatResponse(res, "Could not connect as agent");
}

export async function joinChat({ chatId, roomId, websiteId, rejoin = false }) {
	const missing = requireWebsiteId(websiteId);
	if (missing) return missing;
	if (!chatId || !roomId) {
		return { ok: false, message: "chatId and roomId are required", data: null };
	}
	const res = await PostData(MS5, `${BASE}/agent/join`, {
		chatId,
		roomId,
		websiteId: Number(websiteId),
		rejoin: !!rejoin,
	});
	return parseLiveChatResponse(res, "Failed to join chat");
}

export async function sendAgentMessage({ chatId, roomId, text, websiteId }) {
	const missing = requireWebsiteId(websiteId);
	if (missing) return missing;
	if (!chatId || !roomId) {
		return { ok: false, message: "chatId and roomId are required", data: null };
	}
	const res = await PostData(MS5, `${BASE}/agent/message`, {
		chatId,
		roomId,
		text,
		websiteId: Number(websiteId),
	});
	return parseLiveChatResponse(res, "Failed to send message");
}

export async function endChat({ chatId, roomId, websiteId, confirmed = true }) {
	const missing = requireWebsiteId(websiteId);
	if (missing) return missing;
	if (!chatId || !roomId) {
		return { ok: false, message: "chatId and roomId are required", data: null };
	}
	const res = await PostData(MS5, `${BASE}/agent/end`, {
		chatId,
		roomId,
		websiteId: Number(websiteId),
		confirmed,
	});
	return parseLiveChatResponse(res, "Failed to end chat");
}

export async function confirmAgentClose({ chatId, roomId, websiteId, confirmed = true }) {
	const missing = requireWebsiteId(websiteId);
	if (missing) return missing;
	if (!chatId || !roomId) {
		return { ok: false, message: "chatId and roomId are required", data: null };
	}
	const res = await PostData(MS5, `${BASE}/agent/close/confirm`, {
		chatId,
		roomId,
		websiteId: Number(websiteId),
		confirmed,
	});
	return parseLiveChatResponse(res, "Failed to update close confirmation");
}

export async function postAgentPresence(websiteId, offline = false) {
	const missing = requireWebsiteId(websiteId);
	if (missing) return missing;
	const res = await PostData(MS5, `${BASE}/agent/presence`, {
		websiteId: Number(websiteId),
		offline: !!offline,
	});
	return parseLiveChatResponse(res, "Failed to update agent presence");
}

export { chatIdOf, roomIdOf } from "./liveChatUtils";
